import type { ThreadMessageLike } from "@assistant-ui/react";

/** Key under `metadata.custom` holding the backend message id (written by history + transport). */
export const MESSAGE_BACKEND_ID_KEY = "backendId";

interface MetadataCarrier {
  metadata?: Pick<NonNullable<ThreadMessageLike["metadata"]>, "custom">;
}

/** Backend message id recorded in custom metadata, or undefined when unknown. */
export function getBackendMessageId(
  message: MetadataCarrier | undefined | null,
): string | undefined {
  const id = message?.metadata?.custom?.[MESSAGE_BACKEND_ID_KEY];
  return typeof id === "string" && id ? id : undefined;
}
